module.exports = __webpack_public_path__ + "media/images/projects/7-logo-d1c7e5aa21e187e5c8f9a4fc7fcc6d2b.png";